import React from "react";

const RelatedVideoCard = () => (
  <div className="w-full flex flex-row gap-2 mb-4 animate-pulse">
    <div className="relative w-[168px] h-[94px] flex-none duration-300 hover:scale-[1.03]">
      <div className="w-full h-full bg-gray-300 rounded-sm"></div>
    </div>
    <div className="flex flex-col w-full">
      <div className="w-full h-6 bg-gray-300 rounded-sm"></div>
      <div className="w-2/3 h-4 mt-1 bg-gray-300 rounded-sm"></div>
      <div className="w-2/5 h-4 mt-1 bg-gray-300 rounded-sm"></div>
    </div>
  </div>
);

const RelatedVideoSkeleton = () => {
  let content = new Array(5).fill().map((_, i) => <RelatedVideoCard key={i} />);
  return (
    <div className="col-span-full lg:col-auto max-h-[570px] overflow-y-auto">
      {content}
    </div>
  );
};

export default RelatedVideoSkeleton;
